// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 120) return "content/plugin-codaf-risk-ext-bowtie/624b2b1aa59e5c2416ff02959b02297c.js";
	if (chunkId === 666) return "content/plugin-codaf-risk-ext-bowtie/0fecc1e352ee783b6e6177a947acaeca.js";
	if (chunkId === 10) return "content/plugin-codaf-risk-ext-bowtie/151b3ef0b30fa9b453feab7ce9c6cf15.js";
	// return url for filenames based on template
	return undefined;
};